import React from 'react';
import { RevenueHero } from '../goalsTargetsTypes';
import styles from './RevenueHeroCard.module.css';

interface RevenueHeroCardProps {
  data: RevenueHero;
}

export const RevenueHeroCard: React.FC<RevenueHeroCardProps> = ({ data }) => {
  return (
    <div className={styles.card}>
      <div className={styles.row}>
        <div>
          <p className={styles.label}>Monthly Revenue Target</p>
          <h2 className={styles.value}>{data.achieved}</h2>
          <p className={styles.metaLine}>of {data.target}</p>
          <p className={styles.metaLine}>{data.achievedPct} achieved</p>
        </div>
        <div className={styles.bullsEye}>🎯</div>
      </div>
      <div className={styles.bar}>
        <span className={styles.barFill} style={{ width: `${data.remainingPct}%` }} />
      </div>
      <div className={styles.barFooter}>
        <span>↗ On track to reach 95% of target</span>
        <span>{data.remaining} remaining</span>
      </div>
    </div>
  );
};
